import { InputNumberLocalized } from '@components'

import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useGetZervantDocumentSettings } from '@features/invoicingSettings/hooks/useGetZervantDocumentSettings'

import { useRecurringInvoiceForm } from '../../../../../../../../contexts/recurringInvoiceFormContext'

export const Occurrences = () => {
  const { t } = useTranslation()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()

  const { FormItem } = recurringInvoiceForm

  const { getInvoiceLocale } = useGetZervantDocumentSettings(InvoiceDocumentType.Invoice)
  const locale = getInvoiceLocale()

  return (
    <FormItem
      name="occurrences"
      label={t('external_invoices.editor.form.recurring_invoice_settings.field.occurrences.label')}
      render={({ field: { onChange, ...props } }) => (
        <InputNumberLocalized
          {...props}
          keyboard
          locale={locale}
          max={9999}
          min={1}
          size="sm"
          step={1}
          onChange={(value) => {
            onChange(Math.round(value))
          }}
          withCalculations={false}
          withFormatting={false}
        />
      )}
    />
  )
}
